import styled, { css } from "styled-components";
import * as StyledTypography from "@/styles/Styled.Typography";
import { fluid } from "@/styles/utils/fluid";

export const TocMenu = styled.div`
  display: flex;
  flex-flow: column;
  position: relative;
  width: auto;
  border-radius: 32px;
  border: 4px solid ${({ theme }) => theme.colors.onyx};
  box-sizing: border-box;
  transition: all 0.2s ease-in-out; /* Add smooth transition */
  &::before {
    content: "";
    background-color: ${({ theme }) => theme.colors.white};
    outline: 4px solid ${({ theme }) => theme.colors.white};
    position: absolute;
    border-radius: 24px;
    top: 4px;
    left: 4px;
    right: 4px;
    bottom: 4px;
    z-index: -1;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='24' ry='24' stroke='%23333' stroke-width='2' stroke-dasharray='8%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  }
  padding: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.card.xs,
      maxSize: theme.spacing.card.lg,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.lg,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.lg,
    })};
  /* lg and up - smooth sticky behavior starts here */
  @media (min-width: 900px) {
    ${(props) =>
      props.$sticky &&
      css`
        position: sticky;
        top: ${props.$topOffset}px;
        width: 29vw;
        max-height: 70vh;
        overflow: hidden;
        z-index: 50;
        padding: ${({ theme }) =>
          fluid({
            minSize: theme.spacing.card.md,
            maxSize: theme.spacing.card.lg,
            minVW: theme.breakpointValues.md,
            maxVW: theme.breakpointValues.lg,
            baseFontMin: theme.baseFont.md,
            baseFontMax: theme.baseFont.lg,
          })};

        ${props.$shouldHide
          ? css`
              opacity: 0;
              visibility: hidden;
              pointer-events: none;
              transition: opacity 0.3s ease, visibility 0.3s ease;
            `
          : css`
              opacity: 1;
              visibility: visible;
              pointer-events: auto;
              transition: opacity 0.3s ease, visibility 0.3s ease;
            `}
      `}
  }
  /* xl and up */
  @media ${({ theme }) => theme.breakpoints.xl} {
    padding: ${({ theme }) =>
      fluid({
        minSize: theme.spacing.card.lg,
        maxSize: theme.spacing.card.xl,
        minVW: theme.breakpointValues.lg,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.lg,
        baseFontMax: theme.baseFont.xl,
      })};

    ${(props) =>
      props.sticky &&
      css`
        width: 24vw;
      `}
  }
`;

export const TocMenuSummary = styled(StyledTypography.TypoMenu1)`
  text-align: center;
  hr {
    width: 100px;
    height: 1px;
    border: 0;
    border-top: 1px solid ${({ theme }) => theme.colors.onyx};
    margin: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.element.xs,
        maxSize: theme.spacing.element.xl,
        minVW: theme.breakpointValues.xs,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.xl,
      })}
      auto
    `};
  }
`;

export const TocMenuInnerScroll = styled.ul`
  overflow: hidden;
  overflow-y: scroll;
  list-style: none;
  padding: 0;
  flex: 1; /* Allow it to take available space */
`;

export const TocMenuList = styled(StyledTypography.TypoCaption4)`
  padding: ${({ theme }) => `
    0
    0
    ${fluid({
      minSize: theme.spacing.horizontal.xs,
      maxSize: theme.spacing.horizontal.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
  `};
  &:last-child {
    padding: 0;
  }
  a {
    display: flex;
    transition: color 0.2s ease, font-weight 0.2s ease;
    color: ${({ theme }) => theme.colors.onyx};
    &:hover {
      color: ${({ theme }) => theme.colors.imperialRed};
    }
    &:active {
      color: ${({ theme }) => theme.colors.imperialRed};
      font-weight: ${({ theme }) => theme.fontWeight.bold};
    }
    &.active {
      color: ${({ theme }) => theme.colors.imperialRed};
      font-weight: ${({ theme }) => theme.fontWeight.bold};
    }
  }
`;

export const ArticleMenuList = styled(StyledTypography.TypoBody1)`
  cursor: pointer;
`;
